export const weddingClients = [
  {
    name: "Chris & Medha",
    slug: "chris-medha",
    cover: "/assets/wedding/chris_medha_webp/w28.webp",
    subtitle: "Tuscany, Italy • 2024",
    category: "Destination Wedding",
  },
  {
    name: "Vyshnavie & Anirudh",
    slug: "vyshanavie-anirudh",
    cover: "/assets/w58.jpg",
    subtitle: "Udaipur Palace • 2025",
    category: "Royal Wedding",
  },
  {
    name: "Benny & Vaishnavi",
    slug: "benny-vaishnavi",
    cover: "/assets/wedding/Benny_Vaishnavi_webp/w15.webp",
    subtitle: "Udaipur Palace • 2024",
    category: "Intimate Ceremony",
  },
  // {
  //   name: "Prathyusha & Pavan",
  //   slug: "prathyusha-pavan",
  //   cover: "https://ik.imagekit.io/p3xaqnkci/tagteam/prathyusha_pavan_cover_photo.webp",
  //   subtitle: "Hyderabad • 2024",
  //   category: "Royal Wedding",
  // },
];
